import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import VueAxios from "./plugins/axios";
import Vuebar from "vuebar";
import VueParallaxJs from "vue-parallax-js";

import VueMeta from "vue-meta";
//import './registerServiceWorker'
import { CarouselPlugin } from "bootstrap-vue";
import { TabsPlugin } from "bootstrap-vue";
import { AlertPlugin } from "bootstrap-vue";
import { CollapsePlugin } from "bootstrap-vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import VueJsonLD from "vue-jsonld";
var VueCookie = require("vue-cookie");

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VueAxios);
Vue.use(CarouselPlugin);
Vue.use(TabsPlugin);
Vue.use(Vuebar);
Vue.use(VueParallaxJs);
Vue.use(AlertPlugin);
Vue.use(CollapsePlugin);
Vue.use(VueCookie);
Vue.use(VueJsonLD);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.component("Breadcrumbs", Breadcrumbs);
new Vue({
  router,
  data: {
    phone: "",
    address: "",
    email: "",
    emailExtra: "",
    baseURL: "",
    title: "CADFlo",
    description: "CADFlo Mechanical Analysis Division Mentor Graphics",
  },
  metaInfo() {
    return {
      title: this.$root.title,
      meta: [{ name: "description", content: this.$root.description }],
    };
  },
  mounted() {
    this.$axios.get("/rest/contacts/").then((response) => {
      this.phone = response.data["UF_PHONE"];
      this.address = response.data["UF_ADDRESS"];
      this.email = response.data["UF_EMAIL"];
      this.emailExtra = response.data["UF_EXTRA"].split("<br>");
    });
    if (process.env.NODE_ENV === "development") {
      this.baseURL = "https://cadflo.ru";
    } else {
      this.baseURL = "";
    }

    //let event = new Event('renderer-ready');
    //window.document.dispatchEvent(event);
  },
  methods: {
    async loadContent(paramsGet) {
      let paramsSend = { params: {} };
      paramsGet.forEach((val, key) => (paramsSend["params"][key] = val));

      if (paramsSend["params"]["id"]) {
        if (/^-?\d+$/.test(paramsSend["params"]["id"]) === false) {
          paramsSend["params"]["code"] = paramsSend["params"]["id"];
          delete paramsSend["params"]["id"];
        }
      }

      const { data } = await this.$axios
        .get("/rest/element/", paramsSend)
        .catch(function (error) {
          return [];
        });
      return data;
    },
  },
  render: (h) => h(App),
}).$mount("#app");
